import * as ActionTypes from './actionTypes';
import BrokerS2SManager from './BrokerS2SManager';

export function updateComponentState(type, payload) {
  return { type, payload };
}

export function addWindowRef(references) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.FETCH_PORTAL_REFERENCE, { references }));
  };
}

export function showLogin(showLoginPopUP) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SHOW_LOGIN_POPUP, { showLoginPopUP }));
  };
}

export function resetIdleTimeout(isResetIdleTimeout) {
  return dispatch => {
    BrokerS2SManager.resetIdleTime();
    dispatch(updateComponentState(ActionTypes.RESET_IDLE_TIMEOUT, { isResetIdleTimeout }));
  };
}

export function showSessionExpiredMessage(isSessionExpiredMessage) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SHOW_SESSION_EXPIRY_MESSAGE, { isSessionExpiredMessage }));
  };
}
export function handleShowInvalidUserModal(showInValidUserPopUP) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SHOW_DIFF_USER_POPUP, { showInValidUserPopUP }));
  };
}
export function handleShowActiveTabModal(showActiveTabPopup) {
  return dispatch => {
    dispatch(updateComponentState(ActionTypes.SHOW_ACTIVE_TAB_POPUP, { showActiveTabPopup }));
  };
}
